import { render, staticRenderFns } from "./miniLeader.vue?vue&type=template&id=6a7cf5ca&scoped=true"
import script from "./miniLeader.vue?vue&type=script&lang=js"
export * from "./miniLeader.vue?vue&type=script&lang=js"
import style0 from "./miniLeader.vue?vue&type=style&index=0&id=6a7cf5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7cf5ca",
  null
  
)

export default component.exports